import React from 'react'
import CmsProductCard from 'cms/CmsProductCard'
import SlickSlider from 'cms/components/slider/SlickSlider'

const CmsProductSlider = ({
  style,
  products,
  productSettings,
  sliderSettings,
  defaultImage,
}) => {
  return (
    <SlickSlider
      style={style}
      settings={{ ...sliderSettings }}
      items={
        products.map(
          (product, i) => {
            const loading = !product
            return (
              <div key={i}>
                <CmsProductCard
                  loading={loading}
                  product={product || {}}
                  defaultImage={defaultImage}
                  {...productSettings}
                />
              </div>
            )
          }
        )
      }
    />
  )
}

CmsProductSlider.propTypes = {}
CmsProductSlider.defaultProps = {}

export default CmsProductSlider



// WEBPACK FOOTER //
// ./src/cms/CmsProductSlider.js